module.exports = __webpack_public_path__ + "img/rbcnsystem_bg.423396e7.jpg";